<template>
  <b-row class="h-100">
    <b-colxx sm="12" lg="5" md=10 class="mx-auto my-auto">
      <b-card style="padding: 10px 30px 30px;" no-body>
        <div class="position-relative image-side ">
          <p class=" text-white h2">{{ $t('user.login-title') }}</p>
        </div>
        <div class="form-side">
          <h6 class="mb-4">{{ $t('user.register') }}</h6>
          <b-form @submit.prevent="formSubmit" class="has-float-label mb-4">

            <b-form-group :label="$t('user.username')" class="has-float-label mb-4">
              <b-form-input type="text" v-model="$v.form.username.$model" :state="!$v.form.username.$error"/>
              <b-form-invalid-feedback v-if="!$v.form.username.required">{{ $t('user.necessary') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.form.username.userIdCheck">4~20자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용 가능합니다.
              </b-form-invalid-feedback>

            </b-form-group>

            <b-form-group :label="$t('user.password')" class="has-float-label mb-4">
              <b-form-input type="password" v-model="$v.form.password.$model" :state="!$v.form.password.$error"/>
              <b-form-invalid-feedback v-if="!$v.form.password.required">{{ $t('user.necessary') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.form.password.passCheck">8~16자 영문 대 소문자, 숫자 , 특수문자를 사용 가능합니다.
              </b-form-invalid-feedback>

            </b-form-group>

            <b-form-group :label="$t('user.passwordConfirm')" class="has-float-label mb-4">
              <b-form-input type="password" v-model="$v.form.passwordConfirm.$model"
                            :state="!$v.form.passwordConfirm.$error"/>
              <b-form-invalid-feedback v-if="!$v.form.passwordConfirm.required">{{ $t('user.necessary') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.form.passwordConfirm.sameAsPassword">
                {{ $t('user.password-identical') }}
              </b-form-invalid-feedback>
            </b-form-group>


            <!--            <b-form-group :label="$t('user.fullname')" class="has-float-label mb-4">-->
            <!--              <b-form-input type="number" v-model="form.fullName" v-on:keyup="checkFullName"/>-->
            <!--            </b-form-group>-->


            <b-form-group :label="$t('user.fullname')" class="has-float-label mb-4">
              <b-form-input type="text"
                            v-model="$v.form.fullName.$model"
                            :state="!$v.form.fullName.$error"/>
              <b-form-invalid-feedback v-if="!$v.form.fullName.required">{{ $t('user.necessary') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.form.fullName.nameCheck">이름을 정확히 입력해 주세요.
              </b-form-invalid-feedback>
            </b-form-group>


            <!--            <b-form-group :label="$t('user.email')" class="has-float-label mb-4">-->
            <!--              <b-form-input v-on:input="form.email= $event.target.value"-->
            <!--                            v-on:keyup="checkEmail" type="text" v-model="form.email"/>-->
            <!--            </b-form-group>-->


            <b-form-group :label="$t('user.email')" class="has-float-label mb-4">
              <b-form-input v-model="$v.form.email.$model" type="text" :state="!$v.form.email.$error"/>
              <b-form-invalid-feedback v-if="!$v.form.email.required">{{ $t('user.necessary') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.form.email.email">{{ $t('user.required-email-check') }}
              </b-form-invalid-feedback>
            </b-form-group>


            <!--            <b-form-group :label="$t('user.phoneNumber')" class="has-float-label mb-4">-->
            <!--              <b-form-input id="phone" type="text" v-on:input="$v.form.phoneNumber.$model = $event.target.value"-->
            <!--                            v-on:keyup="checkPhoneNumber" />-->
            <!--            </b-form-group>-->


            <b-form-group :label="$t('user.phoneNumber')" class="has-float-label mb-4">
              <b-form-input id="phone" type="text" v-model="$v.form.phoneNumber.$model"
                            :state="!$v.form.phoneNumber.$error"/>
              <b-form-invalid-feedback v-if="!$v.form.phoneNumber.required">{{ $t('user.necessary') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.form.phoneNumber.phoneNumber">휴대전화를 정확히 입력해 주세요.
              </b-form-invalid-feedback>

            </b-form-group>


            <div class="form-group has-float-label">
              <!--              <v-select :options="selectOption" v-model="form.storeCode" :reduce="item=>item.value"-->
              <!--                        label="label"></v-select>-->

              <b-form-select v-model="$v.form.storeCode.$model" :options="selectOption" plain
                             :state="!$v.form.storeCode.$error"/>
              <b-form-invalid-feedback v-if="!$v.form.storeCode.required">{{ $t('user.necessary') }}
              </b-form-invalid-feedback>
              <span>매장선택</span>
            </div>

            <!--            <div class="form-group has-float-label">-->
            <!--              <b-form-select v-model="$v.form.storeCode" :options="selectOption" :reduce="item=>item.value"></b-form-select>-->
            <!--              <span>매장선택</span>-->
            <!--            </div>-->


            <div class="d-flex justify-content-end align-items-center">
              <b-button to="login" variant="outline-primary" size="" class="btn-shadow">{{ $t('button.back') }}
              </b-button>
              <b-button type="submit" variant="primary" size="lg" class="ml-2 btn-shadow">{{ $t('user.register-button') }}
              </b-button>
            </div>

          </b-form>
        </div>
      </b-card>
    </b-colxx>
  </b-row>
</template>
<script>

import {
  validationMixin,
} from "vuelidate";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css'
import api from "../../constants/api";

import {
  mapGetters,
  mapActions

} from "vuex";

const {
  required,
  maxLength,
  minLength,
  sameAs,
  email,
  helpers
} = require("vuelidate/lib/validators");

const userIdCheck = helpers.regex('userIdCheck', /^[a-zA-Z0-9_-]{4,20}$/);
// const nameCheck = helpers.regex('nameCheck', /^(?=.*[ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z])/);
// const nameCheck = helpers.regex('nameCheck', /^[가-힣]|[a-zA-Z]$/);
const nameCheck = helpers.regex('nameCheck', /^[가-힣]|[a-zA-Z]$/);
const passCheck = helpers.regex('passCheck', /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^*()\-_=+\\\|\[\]{};:\'",.<>\/?]).{8,16}$/);
// const passCheck = helpers.regex('passCheck', /^(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&]{8,16}$/);
const phoneCheck = helpers.regex('phoneCheck', /^[a-zA-Z0-9]{8,16}$/);

export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      isLoad: false,
      selectValue: null,
      selectOption: [],
      form: {
        username: '',
        password: '',
        passwordConfirm: '',
        email: '',
        fullName: '',
        phoneNumber: '',
        storeCode: ''
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      username: {
        required,
        userIdCheck
      },
      password: {
        required,
        passCheck
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs('password')
      },
      fullName: {
        required,
        nameCheck
      },
      email: {
        required,
        email,
      },
      phoneNumber: {
        required,
        phoneCheck
      },
      storeCode: {
        required
      }
    }
  },

  computed: {
    ...mapGetters(["currentUser", "processing", "loginError", "registerSuccess", "siteName"])
  },

  mounted() {
    this.registerReset()
    this.searchData()
  },

  watch: {

    registerSuccess(val) {
      // console.log(val);
      if(val === true) {
        this.$notify('error', "Register Success", ' 회원가입 신청이 완료되었습니다.', {
          duration: 3500,
          permanent: false
        })
        this.$router.push(`/${this.siteName}/user/login`);
      }
    },


    loginError(val) {
      if(val != null) {
        this.$notify("error", "Login Error", val.response.data.message, {
          duration: 3500,
          permanent: false
        });
      }
    }
  },


  methods: {
    typing(e) {
      if(e.target != undefined) {
        this.form.email = e.target.value
      }
    },

    checkPhoneNumber: function(e) {
      this.form.phoneNumber = e.target.value.replace(/[^0-9]/gi, "")
    },

    checkEmail: function(e) {
      console.log(ee);
      console.log(e.target.value);
      this.form.email = e.target.value.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '')
    },

    checkFullName: function() {
      this.form.fullName = this.form.fullName.replace(/^\d+$/gi, '');
    },

    //사이트 내 매장 코드 리스트 검색
    searchData: function() {
      this.isLoad = false
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.brandStoreCode)

      this.$http.get(reqURL, {}).then(res => {
        if(res.data.code === "OK") {
          
          for(let i = 0; i < res.data.data.length; i++) {
            const store = res.data.data[i];
            this.selectOption.push({text: store.storeName, value: store.storeCode})
          }
          this.isLoad = true
        } else {
          throw 400
        }
      }).catch(err => {
        console.log(err.response.data.message);
      })
    },

    ...mapActions(['registerReset', 'register']),

    formSubmit: function() {
      this.$v.$touch();
      this.$v.form.$touch();

      if(!this.$v.form.$anyError) {
        let _data = Object.assign(this.form, {siteName: this.$route.params.sitename});
        this.register(_data)
      }
    }
  }

}
</script>
